module.exports = __webpack_public_path__ + "c11c031a24e2fa31c407914ef534c70d.png";